import { css } from 'lit';

export const style = css`
  [hidden] {
    display: none;
  }
`;
